import Icon from '../components/Icon.vue'

Icon.register({
  'hand-holding-usd': {
    width: 544,
    height: 512,
    paths: [
      {
        d: 'M257.6 144.3L307.6 158.6C311.2 159.6 313.7 163 313.7 166.7 313.7 171.3 309.9 175.1 305.3 175.1H272.5C268.9 175.1 265.4 174.3 262.2 172.9 257.4 170.7 251.8 171.2 248.1 174.9L230.6 192.4C225.3 197.7 225.9 206.7 232.1 210.8 241.6 217.1 252.4 220.9 263.9 222.3V240C263.9 248.8 271.1 256 279.9 256H295.9C304.7 256 311.9 248.8 311.9 240V222.4C342.2 218.8 365.2 191.4 361.2 159.4 358.3 136.4 340.5 118.1 318.3 111.7L268.3 97.4C264.7 96.4 262.2 93 262.2 89.3 262.2 84.7 266 80.9 270.6 80.9H303.4C307 80.9 310.5 81.7 313.7 83.1 318.5 85.3 324.1 84.8 327.8 81.1L345.3 63.6C350.6 58.3 350 49.3 343.8 45.2 334.3 38.9 323.5 35.1 312 33.7V16C312 7.2 304.8 0 296 0H280C271.2 0 264 7.2 264 16V33.6C233.7 37.2 210.7 64.6 214.7 96.6 217.6 119.6 235.4 137.9 257.6 144.3zM533.9 328.1C522.7 317.4 505.4 318.1 493.6 328.1L406.4 402C395.7 411.1 382.4 416 368.6 416H256.9C248.6 416 241.8 408.8 241.8 400S248.6 384 256.9 384H330.8C345.9 384 359.8 373.1 362.2 357.4 365.3 337.4 350.7 320 332.4 320H181.3C155.8 320 131.1 329.3 111.4 346.3L67.5 384H15.1C6.8 384 0 391.2 0 400V496C0 504.8 6.8 512 15.1 512H352C365.7 512 379 507.1 389.8 498L532.6 377C547 364.9 548.1 341.7 533.9 328.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-holding-usd.js
// module id = aNyt
// module chunks = 144